import * as angular from 'angular';
import {NgModule} from '@angular/core';
import {IframeTestComponent} from "./iframe-test.component";
import {RouterModule} from "@angular/router";
import {TooltipModule} from '@wuitk/angular/components/tooltip';
import {SharedModule} from "@ispm/shared/shared.module";

@NgModule({
  imports: [TooltipModule, SharedModule],
  declarations: [IframeTestComponent]
})
export class IframeTestModule {
}
